import { useCallback, useEffect, useState } from "react";
import { ACTIVE_URL } from "@/constants";

export function PageHeroVideo({ slug }: { slug: string }) {
  const [videoUrl, setVideoUrl] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    fetch(`${ACTIVE_URL}/api/page-video/${slug}/`)
      .then(r => r.ok ? r.json() : null)
      .then(data => { if (!cancelled) setVideoUrl(data?.video_url ?? null); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [slug]);

  const videoRef = useCallback((el: HTMLVideoElement | null) => {
    if (!el) return;
    el.muted = true;
    el.defaultMuted = true;
    const tryPlay = () => { el.play().catch(() => {}); };
    tryPlay();
    el.addEventListener("canplay", tryPlay, { once: true });
  }, []);

  if (!videoUrl) return null;

  return (
    <div className="w-full mb-12">
      <div className="max-w-6xl mx-auto bg-black rounded-lg overflow-hidden">
        <video
          ref={videoRef}
          key={videoUrl}
          src={videoUrl}
          autoPlay
          muted
          controls
          playsInline
          preload="auto"
          className="w-full h-auto"
        />
      </div>
    </div>
  );
}
